import { LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { TCreatePost, TPatchPost, TQueryPost } from '@src/modules'

import { request } from './config'

export const createPost = (data: TCreatePost) => request({ url: 'post', method: 'POST', data })
export const getListPost = (params: TQueryPost, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'post/cms', method: 'GET', params }, { token, lang })
export const getPostById = (id: string, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: `post/${id}`, method: 'GET' }, { token, lang })
export const patchPostById = (id: string, data: TPatchPost) => request({ url: `post/${id}`, method: 'PATCH', data })
export const removePostById = (id: string) => request({ url: `post/${id}`, method: 'DELETE' })
export const getTotalPost = (token?: string) => request({ url: `post/total`, method: 'GET' }, { token })
